import { useMutation } from '@tanstack/react-query';

import { type NotificationKey, type NotificationPostRequestBody, postNotification } from '@/services/api/profile/notification';

const useProfileNotificationMutation = <K extends NotificationKey>() => {
  return useMutation<unknown, Error, { key: K; body: NotificationPostRequestBody<K> }>({
    mutationFn: ({ key, body }) => postNotification(key, body),
  });
};

export { useProfileNotificationMutation };
